<template>
  <form class="flex flex-wrap form__company" @submit.prevent="register">
    <div class="input-group w-full md:w-1/2">
      <input v-model="customer.user.name.first" v-validate="'required|alpha_spaces'" type="text" name="nombres"
        class="input__company" placeholder="NOMBRES Y APELLIDOS" @focusout="changeStateInput($event)" />
      <span v-if="errors.has('nombres')" class="pl-1 text-light-red mt-2 font-neue text-sm">{{ errors.first("nombres")
        }}</span>
    </div>
    <div class="input-group w-full md:w-1/2">
      <input v-model="customer.user.name.last" v-validate="{
    required: true,
    regex:
      /^[\u00F1A-Za-z0-9\s\. _]*[\u00F1A-Za-z0-9\s\.][\u00F1A-Za-z0-9\s\. _]*$/,
  }" name="nombre_comercial" data-vv-as="Nombre Comercial" type="text" class="input__company"
        placeholder="NOMBRE COMERCIAL" @focusout="changeStateInput($event)" />
      <span v-if="errors.has('nombre_comercial')" class="pl-1 text-light-red mt-2 font-neue text-sm">{{
    errors.first("nombre_comercial") }}</span>
    </div>
    <div class="input-group w-full md:w-1/2">
      <input v-model="customer.company.name" v-validate="{
    required: true,
    regex:
      /^[\u00F1A-Za-z0-9\s\. _]*[\u00F1A-Za-z0-9\s\.][\u00F1A-Za-z0-9\s\. _]*$/,
  }" name="razon_social" data-vv-as="razon social" type="text" class="input__company" placeholder="RAZÓN SOCIAL"
        @focusout="changeStateInput($event)" @input="customer.company.name = customer.company.name.toUpperCase()" />
      <span v-if="errors.has('razon_social')" class="pl-1 text-light-red mt-2 font-neue text-sm">{{
    errors.first("razon_social") }}</span>
    </div>
    <div class="input-group w-full md:w-1/2">
      <input v-model="customer.company.ruc" v-validate="'required|numeric|min:11'" name="RUC" type="text"
        placeholder="RUC" class="input__company" maxlength="11" @focusout="changeStateInput($event)" />
      <span v-if="errors.has('RUC')" class="pl-1 text-light-red mt-2 font-neue text-sm">{{ errors.first("RUC") }}</span>
    </div>
    <div class="input-group w-full md:w-1/2">
      <input v-model="customer.user.email" v-validate="'required|email'" name="correo" type="email"
        class="input__company" placeholder="E-MAIL" @focusout="changeStateInput($event)" />
      <span v-if="errors.has('correo')" class="pl-1 text-light-red mt-2 font-neue text-sm">{{ errors.first("correo")
        }}</span>
    </div>
    <div class="input-group w-full md:w-1/2">
      <input v-model="customer.phone" v-validate="'required|min:9'" type="tel" name="celular" placeholder="CELULAR"
        class="input__company" maxlength="9" @focusout="changeStateInput($event)" />
      <span v-if="errors.has('celular')" class="pl-1 text-light-red mt-2 font-neue text-sm">{{ errors.first("celular")
        }}</span>
    </div>
    <div class="input-group w-full">
      <input v-model="customer.user.password" v-validate="'required|min:6'" name="password" data-vv-as="contraseña"
        type="password" class="input__complete" placeholder="CONTRASEÑA" @focusout="changeStateInput($event)" />
      <span v-if="errors.has('password')" class="pl-1 text-light-red mt-2 font-neue text-sm">{{ errors.first("password")
        }}</span>
    </div>
    <div class="input-group w-full">
      <input v-model="customer.address" v-validate="{
    required: true,
    regex:
      /^[\u00F1A-Za-z0-9\s\. _]*[\u00F1A-Za-z0-9\s\.][\u00F1A-Za-z0-9\s\. _]*$/,
  }" name="address" data-vv-as="dirección" type="text" class="input__complete" placeholder="DIRECCIÓN"
        @focusout="changeStateInput($event)" />
      <span v-if="errors.has('address')" class="pl-1 text-light-red mt-2 font-neue text-sm">{{ errors.first("address")
        }}</span>
    </div>
    <div class="w-full my-2 flex flex-col">
      <select id="freqEnvios" v-model="customer.freqEnvios" v-validate="'required'" class="freq__envios uppercase"
        data-vv-as="Frecuencia de envios" name="freqEnvios" @focusout="changeStateInput($event)">
        <option value="" disabled>Frecuencia de envíos</option>
        <option value="110">1 a 10 envíos/semana</option>
        <option value="1130">11 a 30 envíos/semana</option>
        <option value="31">31 a más envíos/semana</option>
      </select>
      <span v-if="errors.has('freqEnvios')" class="pl-1 text-light-red mt-2 font-neue text-sm">{{
    errors.first("freqEnvios") }}</span>
    </div>
    <div class="w-full my-2">
      <input id="terminos" v-validate="'required'" class="mr-2" type="checkbox" data-vv-as="Términos y condiciones"
        name="terminos" />
      <a class="text-white font-neue conditions text-xs lg:text-sm uppercase"
        href="https://www.directoapp.pe/terms"
        target="_blank">Acepto los términos y condiciones</a>
    </div>
    <span v-if="errors.has('terminos')" class="pl-1 text-light-red mt-2 font-neue text-sm">{{ errors.first("terminos")
      }}</span>
    <div class="w-full my-2">
      <input id="privacidad" v-validate="'required'" class="mr-2" type="checkbox" data-vv-as="Política de privacidad"
        name="privacidad" />
      <a class="text-white font-neue conditions text-xs lg:text-sm uppercase"
        href="https://www.directoapp.pe/terms"
        target="_blank">Acepto la política de privacidad</a>
    </div>
    <span v-if="errors.has('privacidad')" class="pl-1 text-light-red mt-2 font-neue text-sm">{{
    errors.first("privacidad") }}</span>
    <div class="flex items-center justify-between w-full mt-3">
      <button :analytics="analytics" class="enter__button uppercase font-neue text-xs lg:text-sm">
        <span :class="{ spinner: loading == true }">Registrarme</span>
      </button>
      <div class="text-center mt-1">
        <router-link to="/auth/login"
          class="underline text-white font-neue text-xs lg:text-sm cursor-pointer text__custom">
          ¿YA TIENES CUENTA?
        </router-link>
      </div>
    </div>
  </form>
</template>
<script>
import ButtonRed from "@/components/ui/ButtonRed";

export default {
  name: "RegisterCompany",
  components: {
    ButtonRed,
  },
  data() {
    return {
      terminos: false,
      customer: {
        user: {
          name: {
            first: "",
            last: "",
          },
          email: "",
          password: "",
        },
        phone: "",
        address: "",
        city: "Lima",
        company: {
          ruc: "",
          name: "",
        },
        freqEnvios: "",
      },
      loading: false,
      analytics: {
        eventCategory: "botón",
        eventAction: "clic",
        eventLabel: "registrarme",
      },
    };
  },
  methods: {
    changeStateInput(e) {
      if (e.target.value.length > 0) {
        e.target.classList.add("has-value");
      } else {
        e.target.classList.remove("has-value");
      }
    },
    register() {
      this.$validator
        .validateAll()
        .then((res) => {
          if (res) {
            if (this.loading) return;
            this.loading = true;
            this.$store
              .dispatch("register", this.customer)
              .then(() => {
                this.$swal({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  type: "success",
                  title: "Registro Exitoso",
                });
                this.$router.push("/dashboard");
              })
              .catch((err) => {
                if (err.response.status === 400) {
                  this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    type: "error",
                    title:
                      "El e-mail ingresado ya existe en nuestro sistema, si te olvidaste la contraseña, dale clic en Ya Tienes Cuenta, y recupérala",
                  });
                } else {
                  this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    type: "error",
                    title:
                      "Error en el registro, por favor llámanos para ayudarte",
                  });
                }
              })
              .then(() => {
                this.loading = false;
              });
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss" scoped>
.input-group {
  position: relative;
  margin: 8px auto;
}

.form__company {
  width: 250px;

  @media (min-width: 768px) {
    width: 400px;
    margin-left: 0%;
  }
}

.form-control {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 25px;
  border: none;
  border-bottom: 1px solid lighten(black, 85%);
  background-color: #73c9ff;
  color: var(--main-blue);

  &+label {
    position: absolute;
    top: 10px;
    left: 3px;
    font-weight: bold;
    color: lighten(black, 60%);
    transition: all 0.2s ease-out;
    color: var(--main-blue);
  }

  &:focus {
    outline: none;
    border-width: 2px;
    border-color: #0A50E6;
    transition: all 0.2s ease-out;
  }

  &:focus+label,
  &.has-value+label {
    top: -12px;
    color: white;
    font-size: 10px;
    font-weight: 300;
    background-color: #73c9ff;
  }
}

input:focus {
  outline: none;
}

.conditions {
  font-style: normal;
  font-weight: bold;
  letter-spacing: 0.05em;
  line-height: 19px;

  @media (min-width: 768px) {
    font-size: 15px;
  }
}

.input__company {
  border-bottom: 2px solid white;
  background-color: #73c9ff;
  box-sizing: border-box;
  padding-left: 5px;
  font-size: 14px;
  width: 95%;
  height: 40px;
  color: white;

  @media (min-width: 768px) {
    height: 45px;
  }

  &:focus {
    border: 2px solid #0A50E6;
  }
}

.input__complete {
  box-sizing: border-box;
  border-bottom: 2px solid white;
  background-color: #73c9ff;
  padding-left: 10px;
  width: 100%;
  height: 40px;
  color: white;

  @media (min-width: 768px) {
    height: 45px;
  }

  &:focus {
    border: 2px solid #0A50E6;
  }
}

.enter__button {
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0A50E6;
  color: #73c9ff;
  padding: 10px 0;

  @media only screen and (min-width: 992px) {
    padding: 15px 0;
  }

  &:active {
    outline: none;
    border: 2px solid white;
  }
}

.freq__envios {
  background-color: #73c9ff;
  color: white;
  border: 2px solid white;
  box-sizing: border-box;
  height: 40px;
  font-weight: 500;
  padding-left: 10px;

  &:focus {
    outline: none;
    border-width: 2px;
    border-color: #0A50E6;
    transition: all 0.2s ease-out;
  }

  & option {
    font-weight: 400;
  }
}
</style>
